<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-card v-show="!loading">
                    <v-card-title>Wyszukiwanie</v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="4">
                                    <v-text-field label="Nazwa" v-model="searchName" v-on:keypress.enter="refreshTable"></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field label="Opis" v-model="searchDescription" v-on:keypress.enter="refreshTable"></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox label="Pokazuj tylko prywatne" v-model="onlyPrivates"></v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <v-select label="Typ opisu:" v-model="type" :items="types"></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                <v-card>
                                    <v-card-title>Pokazuj kategorie:</v-card-title>
                                    <v-card-text>
                                        <v-container fluid>
                                            <v-row>
                                                <v-col v-for="elem in categoriesLocal" :key="elem.id">
                                                    <v-checkbox  v-model="elem.selected" :label="elem.description"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click="refreshTable()">Szukaj</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-btn color="info" @click="addNew" v-if="$can('do','POKO_Opisy_Edycja')">Dodaj opis</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table
                        :options.sync="pagination"
                        :items="items"
                        :loading="loading"
                        :server-items-length="totalResults"
                        :footer-props="{itemsPerPageOptions:[10,20,50,100,200],}"
                        :headers="headers">
                    <template v-slot:item.id="{item}">
                        <v-container fluid>
                            <v-row>
                                <v-col>
                                    <v-icon small class="mr-2" @click="editDescription(item)" v-if="$can('do','POKO_Opisy_Edycja')" title="Edytuj">fa-edit</v-icon>
                                    <v-icon small class="mr-2"  @click="deleteDescription(item)" v-if="$can('do','POKO_Opisy_Edycja')" title="Usuń">fa-trash-alt</v-icon>
                                </v-col>
                            </v-row>
                        </v-container>
                    </template>
                    <template v-slot:item.description="{item}">
                        {{  item.description.length > 50 ? item.description.substring(0,50) + '...' : item.description }}
                    </template>
                    <template v-slot:item.is_private="{item}">
                        {{ item.is_private ? 'Tak' : 'Nie'}}
                    </template>
                    <template v-slot:item.description_type="{item}">
                        {{ getDescriptionType(item.description_type) }}
                    </template>
                    <template v-slot:item.categories="{item}">
                        {{ getCategories(item.categories) }}
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-dialog v-model="showAddEditDescription" width="100%">
            <DescriptionEdit v-if="showAddEditDescription" :editedObject="description" :categories="categories" @close="closingEditor"></DescriptionEdit>
        </v-dialog>
    </v-container>
</template>

<script>
    import {  mapActions } from "vuex";
    import swal from "sweetalert";
    import {descriptionService} from "../../services";
    import DescriptionEdit from "./DescriptionEdit";


    export default {
        name: "DescriptionList",
        components: {DescriptionEdit},
        data() {
            return {
                loading: true,
                showAddEditDescription: false,
                description: null,
                pagination: {},
                searchName: '',
                searchDescription: '',
                type: null,
                onlyPrivates: false,
                totalResults: 0,
                items: [],
                categories: [],
                categoriesLocal: [],
                types: [
                    { value: null, text: 'Wszystkie'},
                    {value: 0 , text: 'Rozpoznanie'},
                    {value: 1, text: 'Zalecenia'},
                    {value: 2, text: 'Przebieg'}
                ],
                headers: [
                    { text: 'Nazwa', sortable: true, align: 'left', value: 'name'},
                    { text: 'Opis', sortable: true, align: 'left', value: 'description'},
                    { text: 'Prywatny', sortable: true, align: 'left', value: 'is_private'},
                    { text: 'Typ', sortable: true, align: 'left', value: 'description_type'},
                    { text: 'Kategorie', sortable: true, align: 'left', value: 'categories'},
                    { text: 'Akcje', sortable: false, align: 'right', value: 'id'}
                ]
            }
        },
        methods: {
            ...mapActions("title", ["updateTitle"]),
            ...mapActions("alert", ["error", "success"]),
            getDescriptionType(type)
            {
                if(type == 0)
                    return 'Rozpoznanie'
                if(type == 1)
                    return 'Zalecenia'
                if(type == 2)
                    return 'Przebieg'
            },
            getCategories(categories)
            {
                if(categories && categories.length > 0)
                {
                    let kategorie = []
                    categories.forEach( elem=> {
                        kategorie.push(elem.description)
                    })
                    return kategorie.join()
                }
                return ''
            },
            showError(close, text) {
                swal({
                    title: "Błąd",
                    text: text,
                    icon: "warning",
                    button: "OK"
                }).then(() => {
                    this.loading = false;
                    if (close) {
                        this.$emit("close");
                    }
                });
            },
            closingEditor()
            {
                this.showAddEditDescription = false
                this.refreshTable()
            },
            addNew()
            {
                this.description = null
                this.showAddEditDescription = true
            },
            refreshTable()
            {
                this.loading = true

                this.requestDescriptions().then(data=> {
                    this.items = data.data.result.items,
                        this.totalResults = data.data.result.totalCount
                    this.loading = false
                })
            },
            editDescription(edited)
            {
                this.description = edited
                this.showAddEditDescription = true
            },
            requestDescriptions() {
                const { sortBy, sortDesc, page, itemsPerPage } = this.pagination
                let sortValue = ''
                if(sortBy.length > 0)
                {
                  sortValue = sortBy[0]
                  if(sortDesc.length > 0)
                    sortValue = sortBy[0] + ( sortDesc[0] ? " DESC": "");
                }
                let isPrivate = null
                let categories = null
                let type = null
                if (this.onlyPrivates)
                {
                    isPrivate = true
                }

                if(this.categoriesLocal) {
                    let cat = []
                    this.categoriesLocal.forEach(elem => {
                        if(elem.selected)
                            cat.push(elem.id)
                    })
                    if(cat.length != this.categoriesLocal.length)
                        categories = cat.join(',')
                }
                else
                {
                    categories = null
                }
                if(this.type && this.type > 0)
                    type = this.type

                let req = descriptionService.getDescriptions({ nameText: this.searchName,descriptionText:this.searchDescription,  SkipCount: (page-1) * itemsPerPage, MaxResultCount: itemsPerPage, sorting: sortValue,
                    isPrivate: isPrivate,
                    categories: categories,
                    type: type
                });
                return req.catch(function() {
                    this.error("Błąd pobierania opisów");
                });
            },
            deleteDescription(item)
            {
                swal({
                    title: "Usuwanie opisu",
                    text:  "Czy na pewno chcesz usunąć ten opis?",
                    icon: "warning",
                    buttons: ["Nie", "Tak"],
                    dangerMode: true
                }).then(confirmed => {
                    if (confirmed) {
                        descriptionService.
                        deleteDescription(item.id)
                            .then(resp => {
                                if (resp.data == null || !resp.data.success) {
                                    throw "Error usuwania opisu";
                                } else {
                                    this.success("Usunięto");
                                    this.refreshTable()
                                }
                            })
                            .catch(e => {
                                if(e.response.data != null && e.response.data.error != null)
                                {
                                    let err = e.response.data.error
                                    this.showError(false,err.message)
                                    return
                                }
                                this.showError(false,"Nie można usunąć opisu");
                            });
                    }
                });
            }
        },
        created() {
            this.updateTitle("Opisy");
        },
        mounted() {
            descriptionService.getAllCategories().then((results) => {
                if(results.data && results.data.result)
                {
                    this.categories = results.data.result
                    this.categories.forEach(elem => {
                        this.categoriesLocal.push({ id: elem.id, description: elem.description, selected: true})
                    })
                }
            }).catch(() =>
            {
                this.error("Błąd pobierania kategorii");
            })
        },
        watch: {
            pagination: {
                handler() {
                    this.requestDescriptions().then(data=> {
                        this.items = data.data.result.items,
                            this.totalResults = data.data.result.totalCount
                        this.loading = false
                    })
                },
                deep: true
            }
        },
    }
</script>

<style scoped>

</style>